import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '../../../lib/utils';

export interface ChannelSettingsMenuItemProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  children: ReactNode;
  pending?: boolean;
  destructive?: boolean;
}

/** Menu action used by the Sendbird channel settings user lists. */
export function ChannelSettingsMenuItem({
  children,
  className,
  disabled,
  pending = false,
  destructive = false,
  type = 'button',
  ...props
}: ChannelSettingsMenuItemProps) {
  return (
    <button
      {...props}
      type={type}
      className={cn(
        'flex w-full items-center gap-2 px-3 py-2 text-left text-sm hover:bg-muted disabled:opacity-50',
        destructive && 'text-destructive',
        className
      )}
      disabled={disabled || pending}
    >
      {pending && <Loader2 className="size-4 animate-spin" />}
      {children}
    </button>
  );
}
